module.exports = __webpack_public_path__ + "./images/2d050aaab32a656a8d590e4065e05bc9.png";